"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationMethod = void 0;
exports.AuthorizationMethod = {
    Invalid: "invalid",
    Public: "public",
    AuthorizationHeader: "authorization_header",
    SignedUrl: "signed_url",
    ShareableLink: "shareable_link",
    LivekitToken: "livekit_token",
    LivekitTokenWebsite: "livekit_token_website",
    GenesysApiKey: "genesys_api_key",
};
